import React, { useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { connect } from 'react-redux';
import {
	showHideUserType,
	resetStateVal,
	handleInputChange,
	addProfileDetails,
	sendOTP,
} from '../../redux/profile/profile.actions';
import { userTypeOptions, primaryPurposeOptions } from '../../utils/const';
import { useForm } from 'react-hook-form';
import VerifyMobile from '../common/verifyMobile';

import Card from 'react-bootstrap/Card';
const Details = ({
	sendOTP,
	addProfileDetails,
	profileDetails: {
		isMobVerified,
		fullName,
		userType,
		phone,
		email,
		gender,
		age,
		isParent,
		childrenAge,
		receiveWhatsappNotification,
		isSubscribe,
		whatsappNumber,
		primaryPurpose,
	},
}) => {
	const {
		register,
		handleSubmit,
		watch,
		errors,
		getValues,
		trigger,
	} = useForm();
	const [updatedPhone, setPhone] = useState();
	const [verifySuccess, setVerifySuccess] = useState(false);
	let Child = childrenAge?.split(',') || [0];
	const [indexes, setIndexes] = React.useState(
		Array.from(Array(Child?.length).keys()),
	);
	const [counter, setCounter] = React.useState(Child.length || 1);

	const addChild = () => {
		if (counter < 8) {
			setIndexes((prevIndexes) => [...prevIndexes, counter]);
			setCounter((prevCounter) => prevCounter + 1);
		}
	};

	const removeChild = (index) => () => {
		setIndexes((prevIndexes) => [
			...prevIndexes.filter((item) => item !== index),
		]);
		setCounter((prevCounter) => prevCounter - 1);
	};

	const clearChildren = () => {
		setIndexes([]);
		setCounter(0);
	};

	const revealChild = watch('isParent');

	const revealWhatsapp = watch('receiveWhatsappNotification');

	const onSubmit = (data) => {
		if (isMobVerified) {
			addProfileDetails(data);
		} else {
			verifyMob();
		}
	};

	const getSelectOptionsList = (options, value) => {
		let result = [];
		!!options &&
			options.map(function (val, index) {
				let isSelected = {};
				if (value === val) {
					isSelected['defaultValue'] = 'selected';
				}
				result.push(
					<option {...isSelected} value={val} key={index}>
						{val}
					</option>,
				);
				return true;
			});
		return result;
	};

	const getGenderOptions = () => {
		let genderList = [
			{ id: 'M', val: 'Male' },
			{ id: 'F', val: 'Female' },
			{ id: 'T', val: 'Transgender' },
			{ id: 'O', val: 'Rather not say' },
		];
		let gender_options = [];
		!!genderList &&
			genderList.forEach(function (value, index) {
				let isSelected = {};
				if (gender === value.id) {
					isSelected['defaultValue'] = 'selected';
				}
				gender_options.push(
					<option {...isSelected} value={value.id} key={index}>
						{value.val}
					</option>,
				);
			});
		return gender_options;
	};

	const verifyMob = async () => {
		let vals = getValues();
		setPhone(vals.phone);
		const isValid = await trigger('phone');
		if (!isValid) {
		} else if (phone !== vals.phone || !isMobVerified) {
			sendOTP(vals.phone);
		} else if (isMobVerified) {
			setVerifySuccess(true);
			setTimeout(() => {
				setVerifySuccess(false);
			}, 5000);
		}
	};

	return (
		<span>
			<form id="profileForm" onSubmit={handleSubmit(onSubmit)}>
				<div className="row">
					<div className="col-xs-12 col-md-12 col-sm-12 col-lg-12">
						<Card style={{ padding: '10px' }}>
							<Card.Body>
								<Card.Title>
									<div className="page-header-left">Personal Information</div>
								</Card.Title>
								<Card.Title>
									<div className="profile-page-title">Personal Information</div>
								</Card.Title>
								<div className="row">
									<div className="col-lg-4">
										<div className="form-group has-float-label">
											<input
												type="text"
												className="form-control"
												id="fullName"
												name="fullName"
												placeholder="Name"
												defaultValue={fullName}
												ref={register({
													required: true,
													// eslint-disable-next-line no-useless-escape
													pattern: /^[a-zA-Z\s\.]+$/i,
												})}
											/>
											<span className="profileError">
												{errors.fullName?.type === 'pattern' &&
													'Name should only contain alphabets'}
											</span>
											<span className="profileError">
												{errors.fullName?.type === 'required' && 'Name is required'}
											</span>
											<label htmlFor="fullName">Name*</label>
											<div className="supportText">
												This will appear on your STEP certificate
											</div>
										</div>
									</div>
									<div className="col-lg-4">
										<div className="form-group has-float-label selectdiv">
											<select
												id="gender"
												name="gender"
												defaultValue={gender}
												className="form-control"
												ref={register}
												placeholder="Gender"
											>
												<option value="">Gender</option>
												{getGenderOptions()}
											</select>
											<label htmlFor="Gender">Gender</label>
										</div>
									</div>

									<div className="col-lg-4">
										<div className="form-group has-float-label">
											<input
												name="age"
												type="number"
												defaultValue={age}
												className="form-control"
												ref={register({
													pattern: /^[0-9]+$/i,
													min: 1,
													max: 99,
												})}
											/>
											<label htmlFor="fullName">Age</label>

											<span className="profileError">
												{errors.age?.type === 'min' && 'Age should be greater than 0'}
											</span>

											<span className="profileError">
												{errors.age?.type === 'max' && 'Age should be less than 100'}
											</span>

											<span className="profileError">
												{errors.age?.type === 'pattern' && 'Age should be numeric'}
											</span>
										</div>
									</div>
								</div>
							</Card.Body>
							<Card.Body>
								<Card.Title>
									<div className="profile-page-title">Account</div>
								</Card.Title>

								<div className="row">
									<div className="col-lg-4">
										<div className="form-group has-float-label">
											<input
												type="text"
												className="form-control"
												name="phone"
												id="phone"
												placeholder="phone"
												ref={register({
													required: true,
													pattern: /^[6789]\d{9}$/i,
												})}
												onBlur={verifyMob}
												defaultValue={phone}
											/>
											<label htmlFor="Phone">Phone*</label>
											<span className="profileError">
												{errors.phone?.type === 'required' && 'Phone number is required'}
											</span>
											<span className="profileError">
												{errors.phone?.type === 'pattern' && 'Phone number is not valid'}
											</span>
											<span style={{ color: 'green' }}>
												{verifySuccess && 'Phone number already verified'}
											</span>
										</div>
									</div>

									<div className="col-lg-4">
										<div className="form-group has-float-label">
											<button
												type="button"
												className="btn btn-primary"
												onClick={verifyMob}
											>
												Verify Mobile
											</button>
										</div>
									</div>

									<div className="col-lg-4">
										<div className="form-group has-float-label">
											<input
												type="email"
												className="form-control"
												id="email"
												name="email"
												placeholder="Email"
												ref={register({
													required: true,
													// eslint-disable-next-line no-useless-escape
													pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
												})}
												defaultValue={email}
											/>
											<label htmlFor="Email">Email*</label>
											<span className="profileError">
												{errors.email?.type === 'required' && 'Email id is required'}
											</span>
											<span className="profileError">
												{errors.email?.type === 'pattern' && 'Email id is not valid'}
											</span>
										</div>
									</div>
								</div>
							</Card.Body>
							<Card.Body>
								<Card.Title>
									<div className="profile-page-title">About You</div>
								</Card.Title>
								<div className="row">
									<div className="col-lg-6">
										<div className="form-group has-float-label selectdiv">
											<select
												name="userType"
												defaultValue={userType}
												className="form-control"
												ref={register({ required: true })}
												placeholder="Who are you*"
											>
												<option value="">Who are you*</option>
												{getSelectOptionsList(userTypeOptions, userType)}
											</select>
											<label htmlFor="Who are you*">Who are you*</label>

											<span className="profileError">
												{errors.userType?.type === 'required' &&
													'Please tell us about yourself'}
											</span>
											<div className="supportText">
												This information helps us serve you the right courses. Please choose
												carefully
											</div>
										</div>
									</div>

									<div className="col-lg-6">
										<div className="form-group has-float-label selectdiv">
											<select
												id="primaryPurpose"
												defaultValue={primaryPurpose}
												name="primaryPurpose"
												className="form-control"
												ref={register}
											>
												<option value="">Purpose of using STEP</option>
												{getSelectOptionsList(primaryPurposeOptions, primaryPurpose)}
											</select>
											<label htmlFor="primaryPurpose">Purpose of using STEP</label>
										</div>
									</div>
								</div>
							</Card.Body>
							<Card.Body>
								<div className="row">
									<div className="col-lg-6">
										<div className="form-group ">
											<label htmlFor="isParent" className="label-title">
												Are you a parent?
											</label>

											<input
												type="checkbox"
												name="isParent"
												className="form-control"
												value="1"
												defaultChecked={isParent}
												ref={register}
											/>
										</div>
									</div>

									{revealChild === '1' ||
									(typeof revealChild === 'undefined' && isParent) ? (
										<div className="col-lg-6">
											<div className="form-group ">
												{indexes.map((index, i) => {
													const fieldName = `Child[${index}]`;
													return (
														<div
															className="form-group has-float-label"
															name={fieldName}
															key={fieldName}
														>
															<input
																type="number"
																defaultValue={Child[index]}
																name={`${fieldName}.age`}
																style={{ marginBottom: '15px' }}
																ref={register({
																	min: 1,
																	max: 17,
																	pattern: /^[0-9]+$/i,
																	required: true,
																})}
																className="form-control"
															/>
															<label>Child Age {i + 1}:</label>

															<span className="profileError">
																{errors.Child &&
																	errors.Child[index]?.age?.type === 'min' &&
																	'Child age should be at least 1'}
															</span>

															<span className="profileError">
																{errors.Child &&
																	errors.Child[index]?.age?.type === 'max' &&
																	'Child age should be less than 18'}
															</span>

															<span className="profileError">
																{errors.Child &&
																	errors.Child[index]?.age?.type === 'pattern' &&
																	'Age should be numeric'}
															</span>
															<span className="profileError">
																{errors.Child &&
																	errors.Child[index]?.age?.type === 'required' &&
																	'Please add age or remove field'}
															</span>
															<br />
															<button
																aria-label="remove"
																type="button"
																className="btn btn-info"
																onClick={removeChild(index)}
															>
																Remove
															</button>
														</div>
													);
												})}

												<button
													type="button"
													aria-label="add-child"
													className="btn btn-info"
													style={{
														marginRight: '15px',
														display: `${counter > 7 ? 'none' : 'inline-block'}`,
													}}
													onClick={addChild}
												>
													Add Child
												</button>
												<button
													type="button"
													className="btn btn-info"
													style={{ marginRight: '15px' }}
													onClick={clearChildren}
												>
													Clear Children
												</button>
											</div>
										</div>
									) : null}
								</div>
							</Card.Body>
							<Card.Body>
								<div className="row">
									<div className="col-lg-6">
										<div className="form-group">
											<label
												className="label-title"
												htmlFor="receiveWhatsappNotification"
												style={{ maxWidth: '80%' }}
											>
												Do you wish to receive updates on WhatsApp?
											</label>

											<input
												type="checkbox"
												name="receiveWhatsappNotification"
												className="form-control"
												value="1"
												defaultChecked={!!receiveWhatsappNotification}
												ref={register}
											/>
										</div>
									</div>

									{revealWhatsapp ||
									(typeof revealWhatsapp === 'undefined' &&
										receiveWhatsappNotification) ? (
										<div className="col-lg-6">
											<div className="form-group has-float-label">
												<input
													type="text"
													className="form-control"
													name="whatsappNumber"
													ref={register({
														required: true,
														pattern: /^[789]\d{9}$/,
													})}
													defaultValue={whatsappNumber || getValues()?.phone}
												/>
												<label htmlFor="whatsappNumber">WhatsApp Number</label>
												<span className="profileError">
													{errors.whatsappNumber?.type === 'pattern' &&
														'Incorrect mobile number'}
												</span>
												<span className="profileError">
													{errors.whatsappNumber?.type === 'required' &&
														'Whatsapp number required'}
												</span>
											</div>
										</div>
									) : null}
								</div>
							</Card.Body>
							<Card.Body>
								<div className="row">
									<div className="col-lg-12">
										<div className="form-group ">
											<label
												htmlFor="isSubscribe"
												style={{ maxWidth: '80%' }}
												className="label-title"
											>
												Would you like to receive updates (and offers) on our English
												courses on Email and SMS?
											</label>

											<input
												type="checkbox"
												name="isSubscribe"
												className="form-control"
												value="1"
												defaultChecked={!!isSubscribe}
												ref={register}
											/>
										</div>
									</div>
								</div>
							</Card.Body>
							<Card.Body>
								<button aria-label="save" type="submit" className="btn-save">
									SAVE
								</button>
							</Card.Body>
						</Card>
					</div>
				</div>
			</form>

			<VerifyMobile phone={updatedPhone} />
		</span>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		showHideUserType: (val) => dispatch(showHideUserType(val)),
		resetStateVal: () => dispatch(resetStateVal()),
		handleInputChange: (event) => dispatch(handleInputChange(event)),
		addProfileDetails: (obj) => dispatch(addProfileDetails(obj)),
		sendOTP: (val) => dispatch(sendOTP(val)),
	};
};

const mapStateToProps = (state) => {
	return {
		profileDetails: state.rootReducer.profileDetails,
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Details);
